import { Combobox } from "../Combobox";
import { type ComboboxOption } from "../Combobox/types";
import { graphql } from "@/graphql";
import { useActiveBusinessUnit } from "@/hooks/use-active-business-unit";

export function BusinessUnitPicker() {
  const { activeBusinessUnitId, setActiveBusinessUnitId, businessUnits, loading } = useActiveBusinessUnit();

  if (businessUnits.length <= 1) {
    return null;
  }

  const options: ComboboxOption[] = businessUnits
    .map((bu) => {
      return { value: bu.id, label: bu.name };
    })
    .sort((a, b) => a.label.localeCompare(b.label));

  return (
    <Combobox
      type="single"
      className="bg-white/10 border border-solid border-white/25 h-10 w-full text-white min-w-[200px]"
      options={options}
      loading={loading}
      selected={activeBusinessUnitId || null}
      onChange={setActiveBusinessUnitId}
    />
  );
}

export const businessUnitsQuery = graphql(`
  query BusinessUnitsQuery {
    businessUnits {
      id
      name
    }
  }
`);
